import DeltaCounts from "components/DeltaCounts";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableChildRow } from "../types";

const ModulePullRequestsTableRunDeltaCell = ({
  item: { run },
  ...cellProps
}: TableSimpleCellProps<ModulePullRequestsTableChildRow>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {!run.delta && <TableCellEmpty />}

      {!!run.delta && (
        <DeltaCounts
          size="small"
          align="start"
          variant="flexible"
          direction="column"
          delta={run.delta}
        />
      )}
    </TableSimpleCell>
  );
};

export default ModulePullRequestsTableRunDeltaCell;
